import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { localStorageIdTokenKey } from '../constants';

export const OAuthCallback = () => {
  const location = useLocation();

  useEffect(() => {
    const idToken = new URLSearchParams(location.search).get('idToken');
    if (idToken) {
      localStorage.setItem(localStorageIdTokenKey, idToken)
      if (window.opener) {
        window.close();
      }

      setTimeout(() => {
        window.close();
      }, 1000);
      
    }
  }, [location]);

  return null;
};
